module.exports = __webpack_public_path__ + "assets/b75.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b75.png
// module id = 666
// module chunks = 0